<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.92"
        height="23.892"
        viewBox="0 0 20.92 23.892"
    >
        <g id="icon_open" transform="translate(1.015)">
            <path
                id="Subtraction_1"
                data-name="Subtraction 1"
                d="M2560.077-483.107h0v-8.743a36.875,36.875,0,0,0,4.8.344c.373,0,.744-.008,1.1-.022a36.172,36.172,0,0,0,6.25-.9v4.254l-12.152,5.067Zm5.958-13.874a35.734,35.734,0,0,1-5.958-.576V-507l12.154,4.671v4.718A35.014,35.014,0,0,1,2566.035-496.981Z"
                transform="translate(-2556.459 507)"
                fill="#854b97"
            />
            <path
                id="Path_469"
                data-name="Path 469"
                d="M1832.229,31.92c-1.161,1.2-.811,3.3,1.339,4.4s5.081.931,9.075.625a19.3,19.3,0,0,0,6.9-1.85"
                transform="translate(-1831.575 -24)"
                fill="none"
                stroke="#854b97"
                stroke-linecap="round"
                stroke-width="2"
            />
            <path
                id="Path_470"
                data-name="Path 470"
                d="M1848.172,33.525l3.308,1-2.192,3.115Z"
                transform="translate(-1831.575 -24)"
                fill="#854b97"
            />
        </g>
    </svg>
</template>
